angular.module('am4').factory('randomColorGenerator', function() {
    return function randomColorGenerator() {
        return '#' +
            Math.floor(Math.random() * 16).toString(16) +
            Math.floor(Math.random() * 16).toString(16) +
            Math.floor(Math.random() * 16).toString(16) +
            Math.floor(Math.random() * 16).toString(16) +
            Math.floor(Math.random() * 16).toString(16) +
            Math.floor(Math.random() * 16).toString(16);
    };
});



// WEBPACK FOOTER //
// ./src/app/services/randomColorGenerator.js